import { LoadingPage } from './LoadingPage'
import { PrototypeLoadingPage } from './PrototypeLoadingPage'
import { ArtboardDetailsLoadingPage } from './ArtboardDetailsLoadingPage'
import { SidebarLoadingPage } from './SidebarLoadingPage'
import { SsoLoadingPage } from './SsoLoadingPage'
import { WorkspaceSubscribeLoadingPage } from './WorkspaceSubscribeLoadingPage'
import { IndexLayoutLoading } from './IndexLayoutLoading'
import { WorkspaceSidebarLoadingPage } from './WorkspaceSidebarLoadingPage'

export default Object.assign(LoadingPage, {
  Prototype: PrototypeLoadingPage,
  Artboard: ArtboardDetailsLoadingPage,
  Sidebar: SidebarLoadingPage,
  Sso: SsoLoadingPage,
  WorkspaceSubscribe: WorkspaceSubscribeLoadingPage,
  IndexLayout: IndexLayoutLoading,
  WorkspaceSidebar: WorkspaceSidebarLoadingPage,
})
